import { z } from 'zod/mini'

export const registerSchema = z.object({
  plan: z.optional(z.coerce.number()),
})
